/**
 * Lee la duración de un video desde una URL probando solo el header
 * (`preload='metadata'`). El browser baja unos pocos KB, no el archivo completo.
 * Latencia típica ~100-300 ms.
 *
 * Devuelve la duración en milisegundos. Rechaza si el video no carga o no
 * expone una duración válida.
 *
 */
export const resolveVideoDuration = (videoUrl: string): Promise<number> =>
  new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      const ms = Math.round(video.duration * 1000);
      video.src = '';
      resolve(ms);
    };
    video.onerror = () => {
      video.src = '';
      reject(new Error(`No se pudo cargar metadata de ${videoUrl}`));
    };
    video.src = videoUrl;
  });
